<!-- @format -->

<template>
	<v-container fluid :style="$vuetify.breakpoint.mdAndUp ? 'width: 1660px' : 'width: 100%'">
		<!-- FIRST ROW with header table card and basic tab cards -->
		<v-row class="d-flex align-center mb-1" justify="center">
			<v-img max-height="500" max-width="400" :src="require('../../assets/img/logo.png')">
				<!-- <div class="fill-height repeating-gradient"></div> -->
			</v-img>
		</v-row>
		<!-- SECOND ROW  -->
		<v-row class="d-flex align-start mb-1" justify="center">
			<!-- First DATA TABLE Card -->
			<v-col col md="6">
				<MaterialfyDataHome v-if="userName" cardMaxWidth="500" :cardTitle=userName cardInnerText="Users Usering"
					:cardShowDivider="false" :cardShowActions="false" cardColor="primary" :cardShowSubHeader="false"
					:cardShowAutomatic="false" ref="dataCard">
					<template v-slot:crdInner>
						<!-- <materialfy-apex-donut /> -->
					</template>
				</MaterialfyDataHome>
				<p v-else-if="loading">Cargando...</p>
				<p v-else-if="error">Error al cargar los datos.</p>
			</v-col>
			<!-- V-TAB TO-DO CARD -->
			<v-col col md="6">
				<MaterialfyDataChartHome v-if="userName" ref="dataChart" cardTitle="Beneficios totales." />
				<p v-else-if="loading">Cargando...</p>
				<p v-else-if="error">Error al cargar los datos.</p>
			</v-col>
		</v-row>
		<!-- THIRD ROW -->
		<v-row class="ma-3 d-flex align-start justify-center">
			<v-col md="9">
				<v-responsive :aspect-ratio="16 / 9">
					<MaterialfyCalendar />
				</v-responsive>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import SecureLS from 'secure-ls'
// import { mapGetters } from "vuex"

// this is where the line chart sparkline gets its colors
// const gradients = [
// 	['#222'],
// 	['#42b3f4'],
// 	['red', 'orange', 'yellow'],
// 	['purple', 'violet'],
// 	['#00c6ff', '#F0F', '#FF0'],
// 	['#f72047', '#ffd200', '#1feaea'],
// ]
export default {
	data: () => ({
		bot: null,
		loading: true,
		error: false,
		userName: null

	}),
	async created() {
		try {
			let ls = new SecureLS()

			// state set to the previous token, the authorization Axios header set to same
			const user = ls.get('userKey')
			// console.log(user.user.username)
			this.userName = user.user.username
			// let userGet = mapGetters(["getUser"])
			// console.log(userGet)
			// console.log(this.$store.state.user)
		} catch (err) {
			this.error = true
			console.error('Error al cargar los datos:', err)
		} finally {
			this.loading = false
		}
	},
	mounted() {

		// this.$refs.dataCard.cardTitle = this.userName 

	},
	methods: {
		getUserName() {
			return this.userName
		},
		throwError: function () {
			throw new Error('Sentry Error')
		},
	},
}
</script>

<style>
.repeating-gradient {
	background-image: repeating-linear-gradient(-45deg,
			rgba(255, 0, 0, .25),
			rgba(255, 0, 0, .25) 5px,
			rgba(0, 0, 255, .25) 5px,
			rgba(0, 0, 255, .25) 10px);
}

@media only screen and (min-width: map-get($grid-breakpoints, 'xl')) {
	.container {
		max-width: 1440px !important;
	}
}
</style>
